import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { loadEnvironment } from "@/store/environment/actions";
import { tokenInfo } from "@/store/login/types";

export default defineComponent({
  name: "sdk-profile-card-mini",
  data() {
    return {
      username: "",
      environment: "",
    };
  },
  computed: {
    ...mapGetters({
      tokenInfo,
    }),
  },
  mounted() {
    this.username = this.tokenInfo.user_name.toUpperCase();
    this.$dispatch(loadEnvironment)([this.tokenInfo.environment.id]).then((res: any) => {
      this.environment = res.name;
    });
  },
});
